var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"empty container"},[_c('div',{staticClass:"alert alert-info"},[_vm._v("\n    "+_vm._s(_vm.parent.$t('result.empty'))+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }